import { RequestOptions } from './request-options';

export class RecalcInfoRequest extends RequestOptions {
    Id_RecalcName: number;
    RecalcName: string;
    Description: string;
    Volume: number;
    BulkVolume: number;
    PieceWeight: number;
}


// WEBPACK FOOTER //
// ./src/app/shared/models/recalc-info-request.ts